import { render } from "./ProfileShowContactsEdit.vue?vue&type=template&id=009807f0&lang=pug"
import script from "./ProfileShowContactsEdit.vue?vue&type=script&lang=js"
export * from "./ProfileShowContactsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__